module.exports = __webpack_public_path__ + "img/icn-telegram.2483ea1d.svg";